export default "__VITE_ASSET__88828781__"